import { io } from 'socket.io-client';
import { receiveNewNotification } from '../redux/reducers/notificationReducer';
import store from '../redux/store';
import { showNotification } from '../redux/reducers/uiReducer';

let socket;

// Initialisation de la connexion WebSocket
export const initWebsocket = () => {
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  const baseURL = API_URL.endsWith('/api') 
    ? API_URL.slice(0, -4) 
    : API_URL;
  
  console.log('WebSocket connecting to:', baseURL);
  
  socket = io(baseURL, {
    autoConnect: false
  });
  
  // Événements de connexion
  socket.on('connect', () => {
    console.log('WebSocket connecté');
    
    // Authentification avec le token JWT
    const token = localStorage.getItem('token');
    if (token) {
      socket.emit('authenticate', token);
    }
  });
  
  socket.on('disconnect', () => {
    console.log('WebSocket déconnecté');
  });
  
  // Réception des notifications en temps réel
  socket.on('notification', (notification) => {
    // Ajouter à l'état Redux
    store.dispatch(receiveNewNotification(notification));
    
    // Afficher une notification UI temporaire
    store.dispatch(showNotification({
      type: notification.type === 'error' ? 'error' : 'info',
      title: getNotificationTitle(notification.type),
      message: notification.message,
      duration: 5000
    }));
    
    // Jouer un son de notification si activé dans les préférences
    playNotificationSound();
  });
  
  // Connecter le socket
  socket.connect();
  
  return socket;
};

// Déconnexion du WebSocket
export const disconnectWebsocket = () => {
  if (socket) {
    socket.disconnect();
  }
};

// Réauthentification avec un nouveau token
export const authenticateWebsocket = (token) => {
  if (socket && socket.connected) {
    socket.emit('authenticate', token);
  }
};

// Fonctions utilitaires
const getNotificationTitle = (type) => {
  switch (type) {
    case 'submission_status':
      return 'Statut de soumission';
    case 'order_status':
      return 'Statut de commande';
    case 'new_submission':
      return 'Nouvelle soumission';
    case 'system':
      return 'Information système';
    default:
      return 'Notification';
  }
};

const playNotificationSound = () => {
  // Vérifier les préférences utilisateur
  const soundEnabled = localStorage.getItem('notification_sound') !== 'disabled';
  
  if (soundEnabled) {
    const audio = new Audio('/sounds/notification.mp3');
    audio.play().catch(e => console.log('Erreur lors de la lecture du son:', e));
  }
};

const websocketService = {
  initWebsocket,
  disconnectWebsocket,
  authenticateWebsocket
};

export default websocketService;